// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './Router';
import './index.css';
import './i18';// Import the i18next configuration

import AOS from 'aos';
import 'aos/dist/aos.css'; 

AOS.init();

ReactDOM.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
  document.getElementById('root')
);
